(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
function initArchiveHeader(){
 const toggle=document.querySelector('.uae-menu-toggle');
 const nav=document.getElementById('ArchiveNavigation');
 if(!toggle||!nav||toggle.dataset.ready)return;
 toggle.dataset.ready='true';
 const close=()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('is-open');};
 toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open);});
 nav.addEventListener('click',event=>{if(event.target.closest('a'))close();});
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){close();toggle.focus();}});
 document.addEventListener('click',event=>{if(!event.target.closest('.uae-header'))close();});
}
initArchiveHeader();
document.addEventListener('shopify:section:load',initArchiveHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  function makeQuery(keyword, tags) {
    var clauses = tags.map(function (tag) { return 'tag:"' + tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; });
    if (keyword.trim()) clauses.unshift(tags.length ? '(' + keyword.trim() + ')' : keyword.trim());
    return clauses.join(' AND ') || '*';
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-archive-search]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var form = root.querySelector('[data-search-form]');
      var keyword = form.querySelector('[data-search-keyword]');
      var selects = Array.from(form.querySelectorAll('[data-search-tag]'));
      var params = new URLSearchParams(window.location.search);
      var savedKeyword = params.get('archive_keyword') || '';
      var savedTags = selects.map(function (select) { return params.get('archive_' + select.dataset.searchTag) || ''; });
      if (params.get('archive') === '1' && makeQuery(savedKeyword, savedTags.filter(Boolean)) === keyword.value) {
        keyword.value = savedKeyword;
        selects.forEach(function (select, index) {
          var value = savedTags[index];
          if (!value || !value.startsWith(select.dataset.searchTag + ': ')) return;
          if (!Array.from(select.options).some(function (option) { return option.value === value; })) {
            select.add(new Option(value.slice(select.dataset.searchTag.length + 2), value));
          }
          select.disabled = false;
          select.value = value;
        });
      } else if (keyword.value === '*') keyword.value = '';
      var clear = root.querySelector('[data-search-clear]');
      function updateClear() {
        var url = new URL(form.action);
        if (keyword.value.trim()) { url.searchParams.set('type', 'product'); url.searchParams.set('q', keyword.value.trim()); }
        clear.href = url.toString();
      }
      updateClear();
      keyword.addEventListener('input', updateClear);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var url = new URL(form.action);
        var next = new URLSearchParams(new FormData(form));
        Array.from(next.entries()).forEach(function (pair) { if (!pair[1]) next.delete(pair[0]); });
        var tags = selects.map(function (select) { return select.value; }).filter(Boolean);
        next.set('q', makeQuery(keyword.value, tags));
        next.set('archive', '1');
        next.set('archive_keyword', keyword.value.trim());
        selects.forEach(function (select) { if (select.value) next.set('archive_' + select.dataset.searchTag, select.value); });
        ['preview_theme_id', 'pb'].forEach(function (name) { if (params.has(name)) next.set(name, params.get(name)); });
        url.search = next.toString();
        window.location.assign(url.toString());
      });
      form.querySelector('[data-search-sort]').addEventListener('change', function () { form.requestSubmit(); });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uae-archive"]) return;
  try {
    

function initArchive(root){if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-card]')],filters=[...root.querySelectorAll('[data-filter]')],multi=[...root.querySelectorAll('[data-multi-filter]')],search=root.querySelector('[data-search]'),free=root.querySelector('[data-free]'),favourites=root.querySelector('[data-favourites-only]'),dialog=root.querySelector('dialog');const norm=s=>s.normalize('NFKD').replace(/[\u064B-\u065F\u0670\u0640]/g,'').replace(/[أإآ]/g,'ا').replace(/ى/g,'ي').toLowerCase();const choiceValues=(card,key)=>{const listKey={person:'persons',city:'cities',subject:'subjects'}[key];if(listKey&&card.hasAttribute('data-'+listKey)){try{const list=JSON.parse(card.dataset[listKey]);return Array.isArray(list)?[...new Set(list.map(v=>String(v).trim()).filter(Boolean))]:[]}catch{return[]}}return listKey?(card.dataset[key]||'').split(/[،,;؛]/).map(v=>v.trim()).filter(Boolean):[card.dataset[key]].filter(Boolean)};filters.forEach(select=>{const key=select.dataset.filter;[...new Set(cards.flatMap(c=>choiceValues(c,key)).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'ar')).forEach(v=>select.add(new Option(v,v)));select.addEventListener('change',update)});multi.forEach(group=>{const key=group.dataset.multiFilter;const options=group.querySelector('[data-options]');[...new Set(cards.flatMap(c=>choiceValues(c,key)))].sort((a,b)=>a.localeCompare(b,'ar')).forEach(value=>{const label=document.createElement('label');label.className='uae-multi-option';const input=document.createElement('input');input.type='checkbox';input.value=value;const text=document.createElement('span');text.textContent=value;label.append(input,text);options.append(label);input.addEventListener('change',update)});group.addEventListener('toggle',()=>{if(group.open)multi.forEach(other=>{if(other!==group)other.open=false})});group.addEventListener('keydown',event=>{if(event.key==='Escape'){group.open=false;group.querySelector('summary').focus()}})});root.addEventListener('click',event=>{multi.forEach(group=>{if(!group.contains(event.target))group.open=false})});function update(){let count=0;const selections=multi.map(group=>{const values=[...group.querySelectorAll('input:checked')].map(input=>input.value);const label=group.querySelector('[data-selection]');label.textContent=values.length?values.join('، '):label.dataset.all;return {key:group.dataset.multiFilter,values}});const query=norm(search.value.trim());cards.forEach(c=>{const match=filters.every(s=>!s.value||choiceValues(c,s.dataset.filter).includes(s.value))&&selections.every(({key,values})=>!values.length||values.some(value=>choiceValues(c,key).includes(value)))&&(!free.checked||c.dataset.free==='true')&&(!favourites?.checked||c.dataset.favouriteSaved==='true')&&norm(Object.values(c.dataset).join(' ')).includes(query);c.hidden=!match;if(match)count++});root.querySelector('[data-count]').textContent=new Intl.NumberFormat('ar-AE').format(count);root.querySelector('[data-empty]').hidden=count!==0}search.addEventListener('input',update);free.addEventListener('change',update);favourites?.addEventListener('change',update);document.addEventListener('archive:favourites-updated',update);root.querySelector('[data-reset]').addEventListener('click',()=>{filters.forEach(s=>s.value='');multi.forEach(group=>{group.querySelectorAll('input').forEach(input=>input.checked=false);group.open=false});search.value='';free.checked=false;if(favourites)favourites.checked=false;update()});root.querySelectorAll('[data-open]').forEach(b=>b.addEventListener('click',()=>{root.querySelector('[data-dialog-title]').textContent=b.closest('[data-card]').dataset.title;dialog.showModal()}));root.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});update()}
document.querySelectorAll('[data-archive]').forEach(initArchive);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-archive]').forEach(initArchive));


const archiveMotionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
let archiveMotionFrame=0;
function updateArchiveMotion(){
 archiveMotionFrame=0;
 document.querySelectorAll('.uae-home-motion').forEach(root=>{
  const bounds=root.getBoundingClientRect();
  if(bounds.bottom<0||bounds.top>window.innerHeight)return;
  root.querySelectorAll('.uae-drift').forEach((shape,index)=>{
   const distance=window.innerHeight*.5-(bounds.top+shape.offsetTop+shape.offsetHeight*.5);
   const shift=archiveMotionPreference.matches?0:Math.max(-45,Math.min(45,distance*(index===1?-.055:.045)));
   shape.style.setProperty('--drift',shift+'px');
  });
 });
}
function requestArchiveMotion(){if(!archiveMotionFrame)archiveMotionFrame=requestAnimationFrame(updateArchiveMotion)}
window.addEventListener('scroll',requestArchiveMotion,{passive:true});
window.addEventListener('resize',requestArchiveMotion,{passive:true});
archiveMotionPreference.addEventListener('change',requestArchiveMotion);
document.addEventListener('shopify:section:load',requestArchiveMotion);
requestArchiveMotion();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uae-magazine"]) return;
  try {
    
function setupArchiveReaders(){
  document.querySelectorAll('[data-reader-shell]').forEach(shell=>{
    const button=shell.querySelector('[data-reader-fullscreen]');
    if(!button||button.dataset.ready)return;
    button.dataset.ready='true';button.hidden=false;button.setAttribute('aria-expanded','false');
    let placeholder=null,scrollY=0,bodyStyle='',previousFocus=null;
    const update=()=>{const active=shell.classList.contains('is-expanded')||document.fullscreenElement===shell;button.textContent=active?button.dataset.exit:button.dataset.enter;button.setAttribute('aria-expanded',String(active))};
    const closeExpanded=()=>{
      if(!placeholder)return;
      shell.classList.remove('is-expanded');shell.removeAttribute('role');shell.removeAttribute('aria-modal');shell.removeAttribute('aria-label');
      placeholder.replaceWith(shell);placeholder=null;
      document.body.style.cssText=bodyStyle;window.scrollTo(0,scrollY);update();
      if(previousFocus&&previousFocus.isConnected)previousFocus.focus({preventScroll:true});
    };
    const openExpanded=()=>{
      scrollY=window.scrollY;bodyStyle=document.body.style.cssText;previousFocus=document.activeElement;
      placeholder=document.createElement('div');placeholder.style.height=shell.getBoundingClientRect().height+'px';shell.before(placeholder);
      document.body.append(shell);shell.classList.add('is-expanded');shell.setAttribute('role','dialog');shell.setAttribute('aria-modal','true');shell.setAttribute('aria-label',shell.querySelector('iframe').title);
      document.body.style.position='fixed';document.body.style.top=-scrollY+'px';document.body.style.width='100%';document.body.style.overflow='hidden';update();button.focus({preventScroll:true});
    };
    button.addEventListener('click',async()=>{
      if(placeholder){closeExpanded();return}
      if(document.fullscreenElement===shell){await document.exitFullscreen();return}
      if(!window.matchMedia('(max-width: 900px), (pointer: coarse)').matches&&document.fullscreenEnabled&&shell.requestFullscreen){try{await shell.requestFullscreen();return}catch{}}
      openExpanded();
    });
    shell.addEventListener('keydown',event=>{if(!placeholder)return;if(event.key==='Escape'){event.preventDefault();closeExpanded()}else if(event.key==='Tab'){const frame=shell.querySelector('iframe');if(event.shiftKey&&document.activeElement===button){event.preventDefault();frame.focus()}else if(!event.shiftKey&&document.activeElement===frame){event.preventDefault();button.focus()}}});
    document.addEventListener('fullscreenchange',update);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(placeholder||shell))closeExpanded()});
  });
}
setupArchiveReaders();document.addEventListener('shopify:section:load',setupArchiveReaders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uae-membership"]) return;
  try {
    
function rememberArchiveRenewal(){document.querySelectorAll('.archive-join').forEach(root=>{if(root.dataset.renewalReady)return;root.dataset.renewalReady='true';const choices=[...root.querySelectorAll('input[type="radio"]')];try{const saved=sessionStorage.getItem('archive-renewal-plan');const choice=choices.find(input=>input.value===saved);if(choice)choice.checked=true;}catch{}choices.forEach(input=>input.addEventListener('change',()=>{try{sessionStorage.setItem('archive-renewal-plan',input.value)}catch{}}));});}
rememberArchiveRenewal();document.addEventListener('shopify:section:load',rememberArchiveRenewal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uae-reader"]) return;
  try {
    
function setupArchiveReaders(){document.querySelectorAll('[data-reader-shell]').forEach(shell=>{const button=shell.querySelector('[data-reader-fullscreen]');if(button.dataset.ready)return;button.dataset.ready='true';if(!document.fullscreenEnabled)return;button.hidden=false;button.addEventListener('click',async()=>{try{if(document.fullscreenElement===shell)await document.exitFullscreen();else await shell.requestFullscreen()}catch{button.hidden=true}});document.addEventListener('fullscreenchange',()=>{button.textContent=document.fullscreenElement===shell?button.dataset.exit:button.dataset.enter})})}
setupArchiveReaders();document.addEventListener('shopify:section:load',setupArchiveReaders);

  } catch(e) { console.error(e); }
})();
})();
